import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import '@sparta.sales.utilities/magellan-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<style type=\"text/css\">\n    .tab-nav-module .icon.chat {\n      background-image: url("
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"chat") : depth0)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + ");\n    }\n    .tab-nav-module .icon.call {\n      background-image: url("
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"call") : depth0)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + ");\n      margin-top: 10px;\n    }\n    .tab-nav-module .icon.online-banking {\n      background-image: url("
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"scheduleAppointment") : depth0)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + ");\n    }\n    .tab-nav-module .icon.headset {\n      background-image: url("
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"headset") : depth0)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + ");\n    }\n    .tab-nav-module .icon.get-an-estimate {\n      background-image: url("
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"getAnEstimate") : depth0)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + ");\n      background-size: 30px 25px;\n    }\n\n  </style>\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\""
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"module") : depths[1])) != null ? lookupProperty(stack1,"notSticky") : stack1),{"name":"unless","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":14},"end":{"line":29,"column":66}}})) != null ? stack1 : "")
    + " is-"
    + ((stack1 = container.lambda((depths[1] != null ? lookupProperty(depths[1],"language") : depths[1]), depth0)) != null ? stack1 : "")
    + " tab-nav-module"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"tabs") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.program(8, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":29,"column":102},"end":{"line":29,"column":142}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"cta") : depth0)) != null ? lookupProperty(stack1,"ctaContact") : stack1),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":143},"end":{"line":29,"column":183}}})) != null ? stack1 : "")
    + "\" data-sticky-level=\"2\">\n    <div class=\"inner-sticky-actual "
    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"module") : depths[1])) != null ? lookupProperty(stack1,"scope") : stack1), depth0))
    + "\">\n      <div class=\"row collapse cnx-regular\">\n        <div class=\"small-12 column relative\">\n          <!-- if tabs -->\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"tabs") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":10},"end":{"line":44,"column":17}}})) != null ? stack1 : "")
    + "          <!-- end tabs -->\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cta") : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":46,"column":10},"end":{"line":136,"column":17}}})) != null ? stack1 : "")
    + "        </div>\n      </div>\n    </div>\n  </div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "spa-sticky";
},"6":function(container,depth0,helpers,partials,data) {
    return " tabs";
},"8":function(container,depth0,helpers,partials,data) {
    return " no-tabs";
},"10":function(container,depth0,helpers,partials,data) {
    return "cta-contact";
},"12":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <nav class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"module") : depths[1])) != null ? lookupProperty(stack1,"showMobile") : stack1),{"name":"if","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.program(15, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":35,"column":24},"end":{"line":35,"column":86}}})) != null ? stack1 : "")
    + "  left-side\" data-magellan-expedition=\"true\">\n              <ul class=\"nl-tabs-nav-module\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"tabs") : depth0),{"name":"each","hash":{},"fn":container.program(17, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":16},"end":{"line":41,"column":25}}})) != null ? stack1 : "")
    + "              </ul>\n            </nav>\n";
},"13":function(container,depth0,helpers,partials,data) {
    return "";
},"15":function(container,depth0,helpers,partials,data) {
    return " show-for-medium-up";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <li>\n                    <a id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"class") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":40},"end":{"line":39,"column":78}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"rel") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":78},"end":{"line":39,"column":110}}})) != null ? stack1 : "")
    + "tabindex=\"0\" "
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"external") : depth0),{"name":"unless","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":123},"end":{"line":39,"column":196}}})) != null ? stack1 : "")
    + " href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"link") : depth0), depth0))
    + "\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0))
    + "</a>\n                  </li>\n";
},"18":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "class=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"class") || (depth0 != null ? lookupProperty(depth0,"class") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"class","hash":{},"data":data,"loc":{"start":{"line":39,"column":60},"end":{"line":39,"column":69}}}) : helper)))
    + "\" ";
},"20":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "rel=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"rel") || (depth0 != null ? lookupProperty(depth0,"rel") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"rel","hash":{},"data":data,"loc":{"start":{"line":39,"column":94},"end":{"line":39,"column":101}}}) : helper)))
    + "\" ";
},"22":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-magellan-arrival=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"link") : depth0), depth0))
    + "\"";
},"24":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cta") : depth0),{"name":"with","hash":{},"fn":container.program(25, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":12},"end":{"line":135,"column":21}}})) != null ? stack1 : "");
},"25":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <div class=\"right-side cta inline-item float-right\">\n\n                <div class=\"prequalify-button inline-item\">\n                  <div class=\"note\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"preQualifyNote") || (depth0 != null ? lookupProperty(depth0,"preQualifyNote") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"preQualifyNote","hash":{},"data":data,"loc":{"start":{"line":51,"column":36},"end":{"line":51,"column":58}}}) : helper))) != null ? stack1 : "")
    + "</div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"linkHelper") : depth0),{"name":"if","hash":{},"fn":container.program(26, data, 0, blockParams, depths),"inverse":container.program(28, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":52,"column":18},"end":{"line":69,"column":25}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ctaContact") : depth0),{"name":"if","hash":{},"fn":container.program(35, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":70,"column":20},"end":{"line":78,"column":27}}})) != null ? stack1 : "")
    + "                </div>\n\n                <div class=\"dropdown-control inline-item\" tabindex=\"-1\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"link") : depth0),{"name":"if","hash":{},"fn":container.program(39, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":82,"column":18},"end":{"line":87,"column":25}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"link") : depth0),{"name":"unless","hash":{},"fn":container.program(42, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":88,"column":18},"end":{"line":94,"column":29}}})) != null ? stack1 : "")
    + "                </div>\n\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"link") : depth0),{"name":"unless","hash":{},"fn":container.program(47, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":97,"column":16},"end":{"line":133,"column":27}}})) != null ? stack1 : "")
    + "              </div>\n";
},"26":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"linkHelper") || (depth0 != null ? lookupProperty(depth0,"linkHelper") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"linkHelper","hash":{},"data":data,"loc":{"start":{"line":53,"column":20},"end":{"line":53,"column":36}}}) : helper))) != null ? stack1 : "")
    + "\n";
},"28":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <a\n                      id=\"prequalifyTabNav\"\n                      tabindex=\"-1\"\n                      class=\"spa-btn spa-btn--primary spa-btn--small"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"button-class") : depth0),{"name":"if","hash":{},"fn":container.program(29, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":58,"column":68},"end":{"line":58,"column":112}}})) != null ? stack1 : "")
    + "\"\n                      href=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"button-link") || (depth0 != null ? lookupProperty(depth0,"button-link") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"button-link","hash":{},"data":data,"loc":{"start":{"line":59,"column":28},"end":{"line":59,"column":45}}}) : helper))) != null ? stack1 : "")
    + "\"\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data-options") : depth0),{"name":"if","hash":{},"fn":container.program(31, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":60,"column":22},"end":{"line":62,"column":29}}})) != null ? stack1 : "")
    + "                    >\n                      "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"button-text") || (depth0 != null ? lookupProperty(depth0,"button-text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"button-text","hash":{},"data":data,"loc":{"start":{"line":64,"column":22},"end":{"line":64,"column":39}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"adaHidden") : depth0),{"name":"if","hash":{},"fn":container.program(33, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":65,"column":22},"end":{"line":67,"column":29}}})) != null ? stack1 : "")
    + "                    </a>\n";
},"29":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"button-class") || (depth0 != null ? lookupProperty(depth0,"button-class") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"button-class","hash":{},"data":data,"loc":{"start":{"line":58,"column":89},"end":{"line":58,"column":105}}}) : helper)));
},"31":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        data-options=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"data-options") || (depth0 != null ? lookupProperty(depth0,"data-options") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"data-options","hash":{},"data":data,"loc":{"start":{"line":61,"column":38},"end":{"line":61,"column":54}}}) : helper)))
    + "\"\n";
},"33":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <span class=\"ada-hidden\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"adaHidden") || (depth0 != null ? lookupProperty(depth0,"adaHidden") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"adaHidden","hash":{},"data":data,"loc":{"start":{"line":66,"column":49},"end":{"line":66,"column":62}}}) : helper)))
    + "</span>\n";
},"35":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"toggle-items") : depth0),{"name":"each","hash":{},"fn":container.program(36, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":71,"column":22},"end":{"line":77,"column":33}}})) != null ? stack1 : "");
},"36":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"linked") : depth0),{"name":"unless","hash":{},"fn":container.program(37, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":72,"column":24},"end":{"line":76,"column":39}}})) != null ? stack1 : "");
},"37":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <div class=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"class") || (depth0 != null ? lookupProperty(depth0,"class") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"class","hash":{},"data":data,"loc":{"start":{"line":73,"column":38},"end":{"line":73,"column":47}}}) : helper)))
    + " inline-item\">\n                            <a class=\"sc-phone-number call-us\" tabindex=\"-1\" href=\"javascript:void(1);\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":74,"column":108},"end":{"line":74,"column":114}}}) : helper)))
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":74,"column":116},"end":{"line":74,"column":128}}}) : helper))) != null ? stack1 : "")
    + "</a>\n                              </div>\n";
},"39":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"noContactUs") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.program(40, data, 0),"data":data,"loc":{"start":{"line":83,"column":20},"end":{"line":86,"column":29}}})) != null ? stack1 : "");
},"40":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <a id=\"contact-link\" tabindex=\"-1\" href=\""
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"link") : depth0), depth0)) != null ? stack1 : "")
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"toggle-text") || (depth0 != null ? lookupProperty(depth0,"toggle-text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"toggle-text","hash":{},"data":data,"loc":{"start":{"line":85,"column":82},"end":{"line":85,"column":97}}}) : helper)))
    + "</a>\n";
},"42":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <a id=\"dropdownToggleTabNav\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ctaContact") : depth0),{"name":"if","hash":{},"fn":container.program(43, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":89,"column":49},"end":{"line":89,"column":100}}})) != null ? stack1 : "")
    + " tabindex=\"-1\" href=\"javascript:void(0)\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"toggle-text") || (depth0 != null ? lookupProperty(depth0,"toggle-text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"toggle-text","hash":{},"data":data,"loc":{"start":{"line":89,"column":141},"end":{"line":89,"column":156}}}) : helper)))
    + "</a>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ctaContact") : depth0),{"name":"if","hash":{},"fn":container.program(45, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":90,"column":20},"end":{"line":92,"column":27}}})) != null ? stack1 : "")
    + "                    <div class=\"divot\"></div>\n";
},"43":function(container,depth0,helpers,partials,data) {
    return "class=\"show-for-medium-up\"";
},"45":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      <a id=\"dropdownToggleTabNavSmall\" class=\"show-for-small-only\" tabindex=\"-1\" href=\"javascript:void(0)\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"toggle-text-small") || (depth0 != null ? lookupProperty(depth0,"toggle-text-small") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"toggle-text-small","hash":{},"data":data,"loc":{"start":{"line":91,"column":124},"end":{"line":91,"column":147}}}) : helper))) != null ? stack1 : "")
    + "</a>\n";
},"47":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <div class=\"dropdown-actual\">\n                    <ul class=\"mlo-override\">\n                      <li>\n                        <div class=\"name\">\n                          <span class=\"firstName\"></span> <span class=\"lastName\"></span>\n                        </div>\n                        <div class=\"nml\">NMLS ID: <span class=\"nmlSID\"></span></div>\n\n                      </li>\n                    </ul>\n                    <ul class=\"default\" tabindex=\"-1\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"toggle-items") : depth0),{"name":"each","hash":{},"fn":container.program(48, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":109,"column":22},"end":{"line":125,"column":31}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"getAnEstimateOfCostsLink") : depth0),{"name":"with","hash":{},"fn":container.program(60, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":126,"column":22},"end":{"line":130,"column":31}}})) != null ? stack1 : "")
    + "                    </ul>\n                  </div>\n";
},"48":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"linked") : depth0),{"name":"if","hash":{},"fn":container.program(49, data, 0, blockParams, depths),"inverse":container.program(57, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":110,"column":24},"end":{"line":124,"column":31}}})) != null ? stack1 : "");
},"49":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <li class=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0))
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"linkHelper") : depth0),{"name":"if","hash":{},"fn":container.program(50, data, 0),"inverse":container.program(52, data, 0),"data":data,"loc":{"start":{"line":112,"column":28},"end":{"line":116,"column":35}}})) != null ? stack1 : "")
    + "                          </li>\n";
},"50":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                              "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"linkHelper") || (depth0 != null ? lookupProperty(depth0,"linkHelper") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"linkHelper","hash":{},"data":data,"loc":{"start":{"line":113,"column":30},"end":{"line":113,"column":46}}}) : helper))) != null ? stack1 : "")
    + "\n";
},"52":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                              <a id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" class=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"classForLink") : depth0), depth0))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"target") : depth0),{"name":"if","hash":{},"fn":container.program(53, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":115,"column":80},"end":{"line":115,"column":130}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"rel") : depth0),{"name":"if","hash":{},"fn":container.program(55, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":115,"column":131},"end":{"line":115,"column":172}}})) != null ? stack1 : "")
    + " tabindex=\"-1\" aria-hidden=\"true\" href=\""
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"link") : depth0), depth0)) != null ? stack1 : "")
    + "\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0)) != null ? stack1 : "")
    + "</a>\n";
},"53":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "target=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"target") : depth0), depth0))
    + "\"";
},"55":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "rel=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"rel") : depth0), depth0))
    + "\"";
},"57":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"ctaContact") : depths[1]),{"name":"unless","hash":{},"fn":container.program(58, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":119,"column":26},"end":{"line":123,"column":39}}})) != null ? stack1 : "");
},"58":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <li class=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"class") || (depth0 != null ? lookupProperty(depth0,"class") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"class","hash":{},"data":data,"loc":{"start":{"line":120,"column":39},"end":{"line":120,"column":48}}}) : helper)))
    + "\">\n                              <a class=\"sc-phone-number call-us\" tabindex=\"-1\" aria-hidden=\"true\" href=\"javascript:void(1);\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":121,"column":129},"end":{"line":121,"column":135}}}) : helper)))
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":121,"column":137},"end":{"line":121,"column":149}}}) : helper))) != null ? stack1 : "")
    + "</a>\n                              </li>\n";
},"60":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      <li class=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0))
    + " show-for-small-only\">\n                        "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"link") : depth0), depth0)) != null ? stack1 : "")
    + "\n                      </li>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"icons") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":0},"end":{"line":26,"column":9}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"local") : depth0),{"name":"with","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":0},"end":{"line":141,"column":9}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/tab-nav-module",
  "version": "1.0.6",
  "id": "tabNavModule",
  "containerID": "homeLoansTabNavModule",
  "moduleName": "home-loans-tab-nav-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "tab-nav-module",
  "data": {
    "init": "tabNavModule",
    "options": {
      "scope": "{{module.scope}}",
      "showMobile": "{{module.showMobile}}",
      "notSticky": "{{module.notSticky}}"
    }
  },
  "moduleParams": [{
    "name": "notSticky",
    "type": "string",
    "values": ["true", "false"]
  }, {
    "name": "scope",
    "type": "string"
  }, {
    "name": "showMobile",
    "type": "string",
    "values": ["true", "false"]
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.sales.utilities/magellan-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * @export
 * @class tabNavModule
 * @extends {Module}
 */
class tabNavModule extends Module {
  /**
   * Creates an instance of tabNavModule.
   * @param {Objects} options Module options
   * @param {Objects} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('#tabNavModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
   * @method openContactUsLayer
   * @returns { void }
   */
  openContactUsLayer() {
    $('#get_a_call_back_engagement').click();
  }

  /**
   * @method fadeInModule
   * @returns { void }
   */
  fadeInModule() {
    // fade in
    this.$target.fadeIn(200);
    this.stickyBarTriggerScroll();
  }

  /**
   * @method stickyBarTriggerScroll
   * @returns { void }
   */
  stickyBarTriggerScroll() {
    // fix for sticky bar that doesn't act like a bar when hitting back on browser
    setTimeout(() => $(window).scroll(), 300);
  }

  /**
   * @returns { void }
   */
  init() {
    const $dropdownControl = $('.right-side .dropdown-control');
    const $dropdown = $('.right-side .dropdown-actual');
    if ($dropdown.length > 0) {
      // aria-hidden can't be set with the current link-helper
      const estimateLink = this.settings.target.querySelector('#getAnEstimateOfCostsLink');
      if (estimateLink) {
        estimateLink.setAttribute('aria-hidden', 'true');
      }
      $dropdownControl.off('click.tabnav');
      $dropdownControl.on('click.tabnav', () => {
        $dropdown.toggleClass('active');
        $dropdownControl.toggleClass('active');
        // Remove or Apply the aria-hidden attr after menu toggle
        const dropdownChildren = $dropdown.find('.default')[0].children;
        Array.from(dropdownChildren).forEach(dropdownChild => {
          if (dropdownChild.children[0].getAttribute('aria-hidden')) {
            dropdownChild.children[0].removeAttribute('aria-hidden');
            dropdownChild.parentElement.removeAttribute('aria-hidden');
          } else {
            dropdownChild.children[0].setAttribute('aria-hidden', 'true');
            dropdownChild.parentElement.setAttribute('aria-hidden', 'true');
          }
        });
      });
    }

    /**
     * @name getStickyHeight
     * @desc Transplanted from page anchor utility for smooth scrolling
     * @returns { Number } height
     */
    function getStickyHeight() {
      let height = 0;
      $('.spa-sticky').each(function selector() {
        height += $(this).outerHeight();
      });
      return height;
    }
    $('#large-tab-nav [href^="#"]').on('click.pageAnchorUtility', function pageAnchorUtilityClick() {
      const $el = $(this);
      const href = $el.attr('href');
      const name = href.split('#')[1];
      if (!name) return;
      const $ref = $(`#${name}, [name=${name}]`);
      const offsetHeight = $el.data('offsetHeight') || getStickyHeight();
      if (href && $ref.length) {
        // allow back button to position back to anchor, remembers scroll
        window.history.pushState({}, '', href);
        $('html, body').animate({
          // Add 1 pixel due to sticky issue in iOS only with transform3d.
          // Without transform3d, it works fine with exact calculation.
          scrollTop: $ref.offset().top - offsetHeight + 1
        }, 1000);
      }
    });
    // end page anchor utility

    $('[data-module]').each(function dataModuleEach() {
      const $el = $(this);
      const id = $el.attr('id');
      $el.attr('data-magellan-destination', id);
    });
    $('.get_a_call_back_modal_open').off('click.cta');
    $('.get_a_call_back_modal_open').on('click.cta', this.openContactUsLayer);
    if (spaParams.pageParams.cmCheck === true) {
      $('.nl-tabs-nav-module a').on('click', function tabNavAClickHandler() {
        const $cache = $(this);
        const text = $cache.text();
        $.each(spaParams.pageParams.ddo.page.pageInfo, (index, info) => {
          if (info.tab === text && index < 4) {
            if (text === 'Overview') {
              // eslint-disable-next-line no-undef
              bactm.pageview(0, 0);
            } else if (text === 'Loans') {
              // eslint-disable-next-line no-undef
              bactm.pageview(1, 0);
            } else if (text === 'Resources') {
              // eslint-disable-next-line no-undef
              bactm.pageview(2, 0);
            } else {
              // eslint-disable-next-line no-undef
              bactm.pageview(3, 0);
            }
          }
        });
      });
    }
    this.Events.sub('HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS', this.fadeInModule);
    this.Events.sub('HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE', this.fadeInModule);
    this.Events.sub('HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS', this.fadeInModule);
    this.Events.sub('HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE', this.fadeInModule);
    this.Events.sub('HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_SUCCESS', this.fadeInModule);
    this.Events.sub('HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_FAILURE', this.fadeInModule);
    this.Events.sub('HOME_LOANS_GENERIC_SUCCESS', this.stickyBarTriggerScroll);
  }
}
registerModuleClass({
  moduleClass: tabNavModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { tabNavModule as default, moduleConfig };
